import React from 'react'
import PropTypes from 'prop-types'
import { FormattedDate } from 'react-intl'
import { Columns, Column, Time, Excerpt, P } from './styles'

Authored.propTypes = {
  updatedAt: PropTypes.string.isRequired,
  excerpt: PropTypes.string
}

Authored.defaultProps = {
  excerpt: ''
}

export default function Authored({ updatedAt, excerpt }) {
  return (
    <Columns>
      <Column>
        <Time dateTime={updatedAt}>
          <FormattedDate value={new Date(updatedAt)} />
        </Time>
      </Column>
      <Excerpt>
        <P>{excerpt}</P>
      </Excerpt>
    </Columns>
  )
}
